import { Wrench, BatteryCharging, Settings2, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "@/data/site";

const SERVICES = [
  { icon: BatteryCharging, title: "Pil Değişimi", desc: "Orijinal pil ile hızlı ve garantili değişim" },
  { icon: Settings2, title: "Bakım & Onarım", desc: "Mekanizma bakımı ve her marka saat onarımı" },
  { icon: Wrench, title: "Kordon Değişimi", desc: "Deri, çelik ve silikon kordon seçenekleri" },
];

export const TeknikServis = () => (
  <section
    id="servis"
    data-testid="service-section"
    className="relative overflow-hidden bg-emerald-deep text-ivory py-16 md:py-24 lg:py-32"
  >
    <div className="grain-overlay" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ivory/50">Atılmaz Saat</p>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] uppercase">
            Teknik Servis
          </h2>
          <p className="mt-4 font-serif text-2xl sm:text-3xl italic leading-snug text-gold">
            "Yaşanmışlıklarınızın hatırasını yaşatıyoruz."
          </p>
          <p className="mt-6 max-w-lg text-sm sm:text-base leading-relaxed text-ivory/65 font-light">
            Saatiniz yalnızca bir aksesuar değil; anılarınızın taşıyıcısıdır.
            Atılmaz Saat teknik servisi, her marka kol saatine özenli bakım ve
            onarım hizmeti sunar.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-7">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={0.08 + i * 0.07}>
              <div className="flex items-start gap-4" data-testid={`service-item-${i + 1}`}>
                <span className="h-11 w-11 shrink-0 rounded-full border border-ivory/20 inline-flex items-center justify-center text-ivory/80">
                  <s.icon size={17} strokeWidth={1.6} />
                </span>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">0{i + 1}</p>
                  <h3 className="mt-1 font-serif text-lg font-semibold text-ivory">{s.title}</h3>
                  <p className="mt-1 text-[13px] leading-relaxed text-ivory/55">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <a
            href={waLink("Merhaba, teknik servis hizmetleriniz hakkında bilgi almak ve randevu oluşturmak istiyorum.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="service-cta-button"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-ivory px-8 h-[52px] text-sm font-semibold text-emerald transition-colors duration-300 hover:bg-sand"
          >
            <MessageCircle size={16} />
            Servis için Bize Ulaşın
          </a>
        </Reveal>
      </div>

      <Reveal className="lg:col-span-5">
        <div className="relative aspect-[4/5] max-w-[440px] mx-auto lg:ml-auto lg:mr-0">
          <div className="absolute -inset-3 border border-ivory/20 translate-x-4 translate-y-4" />
          <div className="relative h-full w-full overflow-hidden bg-emerald flex flex-col items-center justify-center text-center p-10">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_30%,rgba(197,160,89,0.1),transparent_70%)]" />
            <div className="grain-overlay" />
            <div className="relative">
              <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-ivory/40">Atılmaz Saat</p>
              <p className="mt-4 font-serif text-4xl sm:text-5xl font-semibold uppercase tracking-tight text-ivory leading-tight">
                Teknik<br />Servis
              </p>
              <div className="mx-auto mt-6 h-px w-16 bg-gold/50" />
              <p className="mt-6 font-serif text-lg italic text-gold leading-snug max-w-[240px]">
                "Yaşanmışlıklarınızın hatırasını yaşatıyoruz."
              </p>
              <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/30">
                2006'dan Beri
              </p>
            </div>
          </div>
          <div className="absolute -bottom-5 -left-5 bg-emerald border border-ivory/15 px-5 py-4 shadow-2xl">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/50">Atılmaz Saat</p>
            <p className="font-serif text-lg font-semibold leading-tight mt-1">Güvenilir Ustalık</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
